import React from 'react'
import './dataPointFact.scss'

export default (props) => (
  <div className='data-point-fact'>
    <span className='value'>{ props.value }</span> <span className='label'>{ props.label }</span>
  </div>
)